export default "__VITE_ASSET__npHeO3wz__"